var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconopenPaperclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.4,
    height: 24.513,
    viewBox: "0 0 21.4 24.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-paperclip",
    "data-name": "Icon open-paperclip",
    d: "M15.346,0a6.245,6.245,0,0,0-4.324,1.81L2.5,10.152a8.415,8.415,0,0,0,11.9,11.9l3.834-3.834L16.113,16.1l-3.558,3.466-.276.4a5.389,5.389,0,0,1-7.668-7.575l8.526-8.434a3.166,3.166,0,0,1,4.416,0,3.111,3.111,0,0,1,0,4.324L9.886,15.856a.824.824,0,0,1-1.165-1.165l.184-.092L11.7,11.716,9.58,9.6,6.6,12.575a3.8,3.8,0,0,0,5.367,5.367l7.668-7.483A6.119,6.119,0,0,0,15.315.031Z",
    transform: "translate(-0.034)",
    fill: "#51595e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconopenPaperclip);
export default __webpack_public_path__ + "static/media/Icon open-paperclip.ea8df2ffbe642e5a95a5bdc1286b3165.svg";
export { ForwardRef as ReactComponent };